import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Layout from '../components/layout'

// markup
const IndexPage = () => {
  return (
    <Layout pageTitle="Ravelry App">
      <div className="pt-16 lg:py-8"> 
        <div class="container mx-auto px-6 md:px-12 grid lg:grid-cols-2 flex items-center ">
          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center lg:text-left">AffirMe - your daily affirmations app</h2>
            <h3 className="my-8 text-lg sm:text-xl md:text-2xl font-light text-white text-center lg:text-left">Get new affirmations daily to overcome your negative thought patterns, boost your mood and adjust your focus to the positive.</h3>
            <h3 className="my-8 text-lg sm:text-xl md:text-2xl font-light text-white text-center lg:text-left">Setup affirmation push notifications, customise the app to your personality, receive writing reminders, plus lots more in the app.</h3>
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
              <div>
                <a href="https://apps.apple.com/us/app/kntd-discover-ravelry-app/id1572271760" target="_blank">
                  <StaticImage 
                    className="w-[180px]"
                    src="../images/ios_appstore_badge.png" 
                    alt="An iPhone running the kntd:discover app" />
                </a>
              </div>
              {/*<div>
                <a href="https://play.google.com/store/apps/details?id=com.samaitch.kntd" target="_blank">
                  <StaticImage 
                    className="w-[160px]"
                    src="../images/android_appstore_badge.png" 
                    alt="An iPhone running the kntd:discover app" />
                </a>
              </div>*/}
            </div>
          </div>
          <div className="text-center pt-6 lg:pt-0 sm:pr-8">
            <StaticImage 
              className="w-full sm:w-[380px]"
              src="../images/iphone_main.png" 
              alt="An iPhone running the kntd:discover app" />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage